import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, distinctUntilChanged } from 'rxjs';
import { RouteSelectionActionTypes } from '../actions/route-selection.action';
import { ChangeCurrentCpId, ChangeCurrentCsaId, ChangeCurrentMcpId, ClearCurrentCsa, ClearCurrentMcp, RouteChanged } from '../actions';

@Injectable()
export class RouterSelectionEffects {
  constructor(private actions$: Actions) {}

  routeChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType<RouteChanged>(RouteSelectionActionTypes.RouteChanged),
      // Guard against resolver re-runs (e.g. tab-switch/fragment-only navigations that re-trigger
      // the route resolver) dispatching the exact same cp/mcp/cs ids again. Without this, every
      // redundant RouteChanged re-fires ChangeCurrent*Id/Clear* reducers, which can cascade into
      // repeated LoadCurrentCp/LoadCurrentMcp dispatches downstream (see check-sheet.component.ts).
      distinctUntilChanged((prev, curr) => prev.cpId === curr.cpId && prev.mcpId === curr.mcpId && prev.csId === curr.csId),
      concatMap(({ cpId, mcpId, csId }) => {
        const actions = [];
        if (cpId !== null) {
          actions.push(new ChangeCurrentCpId(cpId));
        }

        if (mcpId !== null) {
          actions.push(new ChangeCurrentMcpId(mcpId));
        } else {
          actions.push(new ClearCurrentMcp());
        }

        if (csId !== null) {
          actions.push(new ChangeCurrentCsaId(csId));
        } else {
          actions.push(new ClearCurrentCsa());
        }

        return actions;
      }),
    ),
  );
}
